import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as SVG } from "./SVG/feed_over_24h.svg";

const Icon = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} component={SVG} />
));
export default Icon;
